<div class="app-notifs">
    <p *ngIf="data?.from" class="app-from">
        <mat-icon class="announcement-icon" svgIcon="hub_announcements_horn"></mat-icon>
        {{consts.ANNOUNCEMENT_FROM}}
        <span class="name">{{data?.from}}</span>:
    </p>
    <a *ngIf="data?.link"
        [href]="data?.link"
        target="_blank"
        class="app-text"
        (click)="onClick()"
    >
        {{data?.message}}
        <mat-icon svgIcon="hub_open_in_new"></mat-icon>
    </a>
    <p *ngIf="!data?.link" class="app-text-without-link">{{data?.message}}</p>
    <p class="app-name">{{data?.title}}</p>
    <p
        class="app-action"
        *ngIf="data?.actionNeeded"
    >
        <mat-icon svgIcon="hub_flash_on"></mat-icon>
        <span>{{consts.LABEL_ACTION_NEEDED}}</span>
    </p>
    <p
        class="app-date"
        *ngIf="data?.due"
    >
        <mat-icon svgIcon="hub_access_time"></mat-icon>
        <span>{{data?.due | date: consts.TIMESTAMP_FORMAT}}</span>
    </p>
    <a class="clear-annoucement" (click)="clearNotificatioin()"
        *ngIf="data?.title===consts.NOTIF_DXC_HUB && data.announcementID">×</a>
</div>
